import { post } from '@shared/utils/http';

// TODO: API 用户保存订阅到期提醒设置，支持中英文，待替换成 i18n 或下掉
export function handleBalanceWarningSetting(
	isCN: boolean,
	userInfo: Partial<IUser>,
	isContinualSubscriptionCancel = false,
) {
	post<any>({
		url: `/api/resources/v1/balance/remind/subscription/save`,
		data: {
			email: userInfo.email || '',
			phone: userInfo.phone || '',
			open: true,
			location: isCN ? 1 : 2,
			isContinualSubscriptionCancel,
		},
	});
}
